import { render, staticRenderFns } from "./Sidebar.vue?vue&type=template&id=a5ec2110&scoped=true&"
import script from "./Sidebar.vue?vue&type=script&setup=true&lang=js&"
export * from "./Sidebar.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./Sidebar.vue?vue&type=style&index=0&id=a5ec2110&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5ec2110",
  null
  
)

export default component.exports